export default __webpack_public_path__ + "static/article-sightseeing-and-saving-5-tips-for-a-thrifty-holiday-4f23608c0ee99b9b6af533bee3ec7065.jpg";